import { useDataSubmit } from 'Simple/Data.js'

export function useOnIgnoreMatches(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_patient',
  })

  return function onIgnoreMatches() {
    return submit({ type: 'registerPatient' })
  }
}

export function useOnUseSelectedLead(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_patient',
  })

  return function onUseSelectedLead(value) {
    return submit({ type: 'registerPatient', lead_id: value.id })
  }
}

export function useOnUseSelectedPatient(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_patient',
  })

  return function onUseSelectedPatient(value) {
    return submit({ type: 'goToPatient', id: value.id, person: value.person })
  }
}

export function useOnUseSelectedPerson(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_patient',
  })

  return function onUseSelectedPerson(value) {
    return submit({ type: 'addPatientToPerson', person_id: value.id })
  }
}
